import {Text} from '@mantine/core';
import {DataTableColumn} from 'mantine-datatable';
import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {Registration} from '../types';

// Every column is sortable (MODULE_COMPLIANCE_CHECKLIST §3a). The accessor is
// what useTableSort sorts by; render only controls how the cell looks.
export const useRegistrationsTableColumns = (onRecordClick: (record: Registration) => void): DataTableColumn<Registration>[] => [
    {
        accessor: 'id',
        title: I18n.get('ID'),
        sortable: true,
        render: (item) => (
            <Text
                c="blue"
                style={{cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                {item.id}
            </Text>
        ),
    },
    {
        accessor: 'productCode',
        title: I18n.get('Product Code'),
        sortable: true,
    },
    {
        accessor: 'customerIdentifier',
        title: I18n.get('Customer Identifier'),
        sortable: true,
    },
    {
        accessor: 'customerAWSAccountId',
        title: I18n.get('Registration AWS Account ID'),
        sortable: true,
    },
    {
        accessor: 'created',
        title: I18n.get('Created'),
        sortable: true,
        render: (item) => formatTimestamp(item.created),
    },
];
